import { ReactElement } from 'react';
import { Alert, Button } from 'antd';
import { useRouteError, useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';

const ErrorContainer = styled.main`
  max-width: 800px;
  margin: 0 auto;
  padding: 48px 24px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 32px 16px;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 24px;
`;

const ErrorBoundary = (): ReactElement => {
  const error = useRouteError();
  const navigate = useNavigate();

  const handleHomeClick = () => {
    void navigate('/');
  };

  const getErrorMessage = (): string => {
    if (error instanceof Error) {
      return error.message;
    }
    if (typeof error === 'string') {
      return error;
    }
    return '予期しないエラーが発生しました';
  };

  return (
    <ErrorContainer>
      <Alert message='エラーが発生しました' description={getErrorMessage()} type='error' showIcon />
      <StyledButton type='primary' onClick={handleHomeClick}>
        ホームに戻る
      </StyledButton>
    </ErrorContainer>
  );
};

export default ErrorBoundary;
